import { normalizeCountryCode } from './countries.js';
import { playerIdFromPeerId } from '../security/input.js';

export const NICKNAME_KEY = 'dechess-nickname-v1';
export const COUNTRY_KEY = 'dechess-country-v1';
export const PROFILES_KEY = 'dechess-player-profiles-v1';

export function loadOwnCountry() {
  return normalizeCountryCode(localStorage.getItem(COUNTRY_KEY));
}

export function saveOwnCountry(code) {
  const normalized = normalizeCountryCode(code);
  if (!normalized) {
    localStorage.removeItem(COUNTRY_KEY);
    return '';
  }
  localStorage.setItem(COUNTRY_KEY, normalized);
  return normalized;
}

/** Clear display name, flag, and cached profile for this browser identity. */
export function clearOwnDisplayIdentity(playerId = '') {
  localStorage.removeItem(NICKNAME_KEY);
  localStorage.removeItem(COUNTRY_KEY);
  if (!playerId) {
    return;
  }
  const profiles = readProfiles();
  if (profiles[playerId]) {
    delete profiles[playerId];
    writeProfiles(profiles);
  }
}

function readProfiles() {
  try {
    return JSON.parse(localStorage.getItem(PROFILES_KEY)) || {};
  } catch {
    return {};
  }
}

function writeProfiles(profiles) {
  localStorage.setItem(PROFILES_KEY, JSON.stringify(profiles));
}

export function getPlayerProfile(playerId) {
  if (!playerId) {
    return null;
  }
  return readProfiles()[playerId] || null;
}

export function rememberPlayerProfile(playerId, { nickname, country } = {}) {
  if (!playerId) {
    return null;
  }
  const profiles = readProfiles();
  const previous = profiles[playerId] || {};
  const next = {
    ...previous,
    playerId,
    updatedAt: Date.now()
  };
  const cleanNickname = nickname == null ? '' : String(nickname).trim().slice(0, 32);
  if (cleanNickname) {
    next.nickname = cleanNickname;
  }
  // Never clear a known country when later mesh/rendezvous rows omit it.
  const normalizedCountry = country == null ? '' : normalizeCountryCode(country);
  if (normalizedCountry) {
    next.country = normalizedCountry;
  }
  profiles[playerId] = next;
  writeProfiles(profiles);
  return next;
}

export function rememberPeerProfiles(peers = []) {
  for (const peer of peers) {
    const playerId = peer?.metadata?.playerId
      || peer?.playerId
      || playerIdFromPeerId(peer?.peerId);
    if (!playerId) {
      continue;
    }
    rememberPlayerProfile(playerId, {
      nickname: peer.metadata?.nickname || peer.nickname,
      country: peer.metadata?.country || peer.country
    });
  }
}
